import * as React from "react"
import {utinc} from './priceDisplay.module.scss'

const PriceDisplay = ({ startingPrice, endingPrice,utilitiesIncluded=false }) => {
    return (
      <p className="subtitle is-6 floorplan-subtitle">
        {startingPrice === endingPrice ? (
          `Starting at $${startingPrice}${utilitiesIncluded ? '*' : ''}`
        ) : (
          <>
            ${startingPrice} - ${endingPrice}
          </>
        )}
        {utilitiesIncluded && <span className={utinc}>*Utilities Included</span>}
      </p>
    );
  };
  
export default PriceDisplay